<template>
  <div id="tabs-container">
    <keep-alive>
      <org-card-list />
    </keep-alive>
    <v-fab-transition>
      <v-btn  v-if="$can('createOrg')" :key="activeFab.icon" :color="activeFab.color" class="screen-fixed" dark fab fixed x-large @click="creatNode">
        <v-icon>{{ activeFab.icon }}</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import OrgCardList from "./Sections/OrgCardList.vue"
import { AmplifyEventBus } from "aws-amplify-vue"
// import { Logger } from "aws-amplify"
// const logger = new Logger("AdminHome")
export default {
  components: { OrgCardList },
  data: () => ({ activeFab: { color: "red", icon: "mdi-plus" } }),
  methods: {
    creatNode() {
      AmplifyEventBus.$emit("createNode", "createOrg")
    },
  },
}
</script>

<style lang="scss">
#tabs-container {
  position: relative;
}
</style>
